import React, {useEffect} from 'react';
import {Container} from 'react-bootstrap';
import {NavigationBar} from '../components/NavigationBar';
import {Footer} from '../components/Footer';
import {ProjectForm} from '../components/ProjectForm';

export const Projects = () => {

  useEffect(() => {
    document.title = "Inscribir proyecto - FabLab UTFSM";
  });

  return (
      <Container className="fablab-page" fluid>                                
          <NavigationBar/>
          <ProjectForm/>
          <Footer/>
      </Container>
  )
}